import { useEffect, useRef } from "react"

/**
 * Закрытие по Esc для всего, что перекрывает страницу: лайтбокс, выпадающие
 * списки, режимы замены.
 *
 * Слушаем `window`, а не поле ввода: список подсказок остаётся на экране и
 * после того, как фокус ушёл, и обработчик на `input` в этот момент уже не
 * сработает. Открытые слои складываются в стек, и Esc закрывает только
 * верхний — иначе одно нажатие сворачивало бы сразу и подсказки, и режим
 * замены, и лайтбокс над ними.
 */

const stack: Array<() => void> = []

function onKeyDown(event: KeyboardEvent) {
	if (event.key !== "Escape" || stack.length === 0) return
	event.preventDefault()
	stack[stack.length - 1]()
}

export function useEscape(active: boolean, onEscape: () => void) {
	// обработчик держим в ref: иначе слой пересоздавался бы в стеке на каждый
	// рендер и терял своё место в нём
	const handler = useRef(onEscape)
	useEffect(() => {
		handler.current = onEscape
	})

	useEffect(() => {
		if (!active) return

		const entry = () => handler.current()
		stack.push(entry)
		if (stack.length === 1) window.addEventListener("keydown", onKeyDown)

		return () => {
			const at = stack.indexOf(entry)
			if (at >= 0) stack.splice(at, 1)
			if (stack.length === 0) window.removeEventListener("keydown", onKeyDown)
		}
	}, [active])
}
